/**
* Case Study Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Case Study Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'case-study-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.case-study-slider-content__splide' ).length ) {
        $( '.case-study-slider-content__splide' ).each( function( index, element ) {
          const main = new Splide( element, {
            type: 'fade',
            rewind: true,
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            drag: false,
          } );

          const siblingContainer = $( element ).closest( '.component-spacing' ).find( '.case-study-slider-images__splide' );

          if ( siblingContainer.length ) {
            const images = new Splide( siblingContainer[0], {
              type: 'fade',
              rewind: true,
              perPage: 1,
              perMove: 1,
              pagination: false,
            } );

            main.sync( images );
            main.mount();
            images.mount();
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'case-study-slider', COMPONENT );
} )( app );
